import React, { createContext, useEffect, useState } from "react";
import { IBillContext, IClient, IProducts, ITypeDocument } from "Interfaces/BillContext";
import { useSettings } from "Context/Settings/useSettings";

export const BillContext = createContext<IBillContext | undefined>(undefined)

export const BillProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const settings = useSettings()
    const Taxes = 0.13
    const [taxesValue, setTaxesValue] = useState(Taxes)
    const [client, setClient] = useState<IClient | null>(null);
    const [listNum, setListNum] = useState(0)
    const [products, setProducts] = useState<IProducts[]>([]);
    const [notes, setNotes] = useState<string>("");
    const [salesPersonCode, setSalesPersonCode] = useState<number>(0);
    const [excentTax, setExcentTax] = useState<boolean>(false);
    const [typePayment, setTypePayment] = useState<string>("");
    const [documentNumber, setDocumentNumber] = useState<number>(0);
    const [nameEmployee, setNameEmployee] = useState<string>("");
    const [typeDocument, setTypeDocument] = useState<ITypeDocument>("TKT");

    // Fechas del documento
    const [documentDate, setDocumentDate] = useState<string>("");
    const [documentDateConta, setDocumentDateConta] = useState<string>("");
    const [documentDateExpiration, setDocumentDateExpiration] = useState<string>("");

    useEffect(() => {
        calculateTotals();
    }, [products]);

    const initBill = () => {
        setDocumentDate(() => settings.getDateFormat(new Date(), "sql"))
        setDocumentDateConta(() => settings.getDateFormat(new Date(), "sql"))
        setDocumentDateExpiration(() => settings.getDateFormat(new Date(), "sql"))
    }

    const reset = () => {
        setClient(null);
        setProducts([]);
        setNotes("");
        setSalesPersonCode(0);
        setExcentTax(false);
        setTypePayment("");
        setDocumentNumber(0);
        setDocumentDate("");
        setDocumentDateConta("");
        setDocumentDateExpiration("");
        setNameEmployee("");
        setTypeDocument("TKT");
        setTaxesValue(Taxes)
        initBill()
    };

    const calculateTotals = () => {
        // Implementa la lógica de cálculo aquí
    };

    // Metodo para agregar productos nuevos o agregarlos mediante el buscador
    const addProducts = ( product: IProducts ) => {
        if (products.length === 0) setProducts([product])
        else {
            setProducts((prev: IProducts[]) => {
                const found = prev.find(item => item.itemCode === product.itemCode);
                if (found) {
                    return prev.map(item => {
                        if (item.itemCode === product.itemCode) {
                            const newQuantity = item.quantity + 1;
                            return {
                                ...item,
                                quantity: newQuantity,
                                totalLine: (item.priceIVA * newQuantity) - item.priceIVA * item.discount
                            };
                        }
                        return item;
                    });
                } else {
                    return [...prev, product];
                }
            });
        }
    }

    // Metodo para eliminar los productos que se tengan
    const deleteProducts = ( itemCode: string ) => {
        setProducts((prev) => {
            let values = prev.filter((item) => item.itemCode !== itemCode)
            return values
        })
    }

    return (
        <BillContext.Provider value={{
            client, setClient,
            products, setProducts, 
            taxesValue, setTaxesValue,
            listNum, setListNum,
            notes, setNotes, 
            salesPersonCode, setSalesPersonCode, 
            excentTax, setExcentTax, 
            typePayment, setTypePayment, 
            documentNumber, setDocumentNumber, 
            documentDate, setDocumentDate, 
            documentDateConta, setDocumentDateConta, 
            documentDateExpiration, setDocumentDateExpiration, 
            nameEmployee, setNameEmployee, 
            typeDocument, setTypeDocument,
            Taxes,
            reset,
            initBill,
            calculateTotals,
            addProducts,
            deleteProducts
        }}>
            { children }
        </BillContext.Provider>
    )
}